import { formatStatsLine } from '@/learn/completed/_lib/format-marginalia'

// Surface C row 4 — Stats live as text. NO accuracy ring, NO donut chart, NO
// trophy icon, NO progress bar (§12.2 explicit bans). Single line, tabular-nums
// so columns stay aligned across replays.
//
// Body-fg ink keeps it subordinate to the headline above; this is the second
// reading of the same fact (the marginalia top names it; the line restates it
// as the prose under the grid). Two passes, two registers, one number.
export function StatsLine({
    kanjiCount,
    correctCount,
    firstTryRate,
}: {
    kanjiCount: number
    correctCount: number
    firstTryRate: number
}) {
    return (
        <p className="mt-6 text-center font-serif text-body-sm text-body-fg tabular-nums md:mt-8">
            {formatStatsLine(kanjiCount, correctCount, firstTryRate)}
        </p>
    )
}
